const Coupons = () => {

  return (
    <div className="hk-pg-wrapper">
      <div className="hk-pg-body py-0">
        <div className="page-wrap">
          <div className="page-content ps-0">
            <div className="page-detail-wrap">
              <header className="page-header">
                <div>
                  <div className="page-title">
                    <h2 className="mb-0">Manage Coupons</h2>
                  </div>
                </div>
                <div className="page-options-wrap">
                  <a className="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover no-caret d-lg-inline-block d-none"
                    href="#" data-bs-toggle="tooltip" data-bs-placement="top" title=""
                    data-bs-original-title="Sync Templates"><span className="btn-icon-wrap"><span
                      className="feather-icon"><i data-feather="refresh-cw"></i></span></span></a>
                  <div className="v-separator d-lg-inline-block d-none"></div>
                  <button type="button" className="btn btn-dark btn-rounded">
                    <span>
                      <span className="icon"><i className="ri-add-line bticon"></i></span>
                      <span>Create New</span>
                    </span>
                  </button>

                  <a className="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover hk-navbar-togglable d-lg-inline-block d-none"
                    href="#" data-bs-toggle="tooltip" data-bs-placement="top" title=""
                    data-bs-original-title="Collapse">
                    <span className="btn-icon-wrap">
                      <span className="feather-icon"><i data-feather="chevron-up"></i></span>
                      <span className="feather-icon d-none"><i data-feather="chevron-down"></i></span>
                    </span>
                  </a>
                </div>
              </header>
              <div className="page-body">
                <div data-simplebar className="nicescroll-bar">
                  <div className="container-fluid">

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Coupons